import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { quotationRevisionsBackend } from './quotation-revisions.backend';
import { quotationRevisionsReducer } from './quotation-revisions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('quotationRevisions', quotationRevisionsReducer),
    BackendModule.forFeature('quotationRevisions', quotationRevisionsBackend),
  ],
})
export class DatastoreQuotationRevisionsModule {}
